import React from 'react';
export var AccordionContext = /*#__PURE__*/React.createContext({
  isControlled: false
});
export var AccordionContextProvider = AccordionContext.Provider;